/* @ngInject */
export default class FullscreenLoaderController {
	constructor($rootScope, $timeout, $location) {
		this.isWaiting = false;
		this.loadingTooLong = false;

		// Define a list of all URL where NOT to show the fullscreen loader
		this.blackListURL = ['/'];

		// Observe the $rootScope.waiting variable
		// And propagate it to the local state if the URL is not blacklisted
		$rootScope.$watch('waiting', () => {
			const currentURLPath = $location.path();
			if (!this.blackListURL.includes(currentURLPath)) {
				this.isWaiting = $rootScope.waiting;
				if (this.isWaiting) {
					$timeout(() => {
						this.loadingTooLong = true;
					}, 2000);
				}
				else {
					this.loadingTooLong = false;
				}
			}
		});

		this.abortRequest = () => {
			$rootScope.$emit('API.abort', 'abort');
		};
	}
}
